// @ts-nocheck
/* eslint-disable */
const toolbar = {
  methods: {
    /**
     * @description Init xử lý sự kiện cho các button
     * @author PHNam
     */
    initToolbar () {
      const me = this
      const container = me.$commonFn.getContainerElement(me.getContainer())

      const handler = function (instance, event: Event) {
        if (typeof me.onToolbarItemClick === 'function') {
          event.stopImmediatePropagation()
          me.onToolbarItemClick.call(me, instance.commandName, instance)
        }
      }
      if (container) {
        const buttons = container.querySelectorAll('.ms-button')

        for (let i = 0; i < buttons.length; i++) {
          const button = buttons[i]
          const instance = buttons[i].__vue__

          if (instance && instance.commandName) {
            button.removeEventListener('click', handler)
            button.addEventListener('click', handler.bind(me, instance))
          }
        }
      }
    }
  }
} 

export default toolbar
